"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _Icons = require("../Icons");
var _utilities = require("../utilities");
var _SeatBase = require("./SeatBase.styles");
const _excluded = ["classes", "className", "state", "orientation", "category", "size", "petsAllowed"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CONTAINER_SIZE_MAP = {
  standard: '0 0 50 50',
  recline: '0 0 50 66',
  premium: '0 0 50 98'
};
const CONTAINER_SIZE_SHAPE = {
  standard: 'M1 13C1 6.37258 6.37258 1 13 1H37C43.6274 1 49 6.37258 49 13V37C49 43.6274 43.6274 49 37 49H13C6.37258 49 1 43.6274 1 37V13Z',
  recline: 'M1 13C1 6.37258 6.37258 1 13 1H37C43.6274 1 49 6.37258 49 13V53C49 59.6274 43.6274 65 37 65H13C6.37258 65 1 59.6274 1 53V13Z',
  premium: 'M1 13C1 6.37258 6.37258 1 13 1H37C43.6274 1 49 6.37258 49 13V85C49 91.6274 43.6274 97 37 97H13C6.37258 97 1 91.6274 1 85V13Z'
};
const PETS_SEAT_DEFAULT = false;
const SEAT_ROTATION_Y_OFFSETS = {
  standard: {
    sm: 0,
    md: 0,
    lg: 0
  },
  recline: {
    sm: -4,
    md: -8,
    lg: -8
  },
  premium: {
    sm: -12,
    md: -20,
    lg: -24
  }
};
function getSizeClassKey(size, category) {
  return `petSeat${(0, _utilities.capitalizeFirstWord)(size)}${(0, _utilities.capitalizeFirstWord)(category)}`;
}

/**
 * Display a SeatBase for selection when booking a trip.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-inputs-seatbase--page)
 */
const SeatBase = props => {
  const {
      classes: classesOverrides,
      className,
      state = 'available',
      orientation = 'top',
      category = 'standard',
      size = 'lg',
      petsAllowed = PETS_SEAT_DEFAULT
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    cx,
    classes
  } = (0, _SeatBase.useStyles)(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  let icon = /*#__PURE__*/React.createElement(_Icons.PetsPawLG, {
    className: cx(classes.paw, classes[orientation])
  });
  if (size === 'sm') {
    icon = /*#__PURE__*/React.createElement(_Icons.PetsPawSM, {
      className: cx(classes.paw, classes[orientation])
    });
  } else if (category === 'recline' && (size === 'lg' || size === 'md')) {
    icon = /*#__PURE__*/React.createElement(_Icons.PetsPawMD, {
      className: cx(classes.paw, classes[orientation])
    });
  } else if (category === 'standard' && size === 'md') {
    icon = /*#__PURE__*/React.createElement(_Icons.PetsPawMD, {
      className: cx(classes.paw, classes[orientation])
    });
  }
  const viewBox = CONTAINER_SIZE_MAP[category];
  const containerShape = CONTAINER_SIZE_SHAPE[category];
  const standard = React.useRef(/*#__PURE__*/React.createElement("g", {
    className: classes.back
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M5 13C5 6.37258 10.3726 1 17 1H33C39.6274 1 45 6.37258 45 13V37C45 43.6274 39.6274 49 33 49H17C10.3726 49 5 43.6274 5 37V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M1 13C1 10.7909 2.79086 9 5 9C7.20914 9 9 10.7909 9 13V37C9 39.2091 7.20914 41 5 41C2.79086 41 1 39.2091 1 37V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M41 13C41 10.7909 42.7909 9 45 9C47.2091 9 49 10.7909 49 13V37C49 39.2091 47.2091 41 45 41C42.7909 41 41 39.2091 41 37V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M1 38.3333C1 35.3878 3.39043 33 6.33595 33C20.1958 33 29.8042 33 43.6641 33C46.6096 33 49 35.3878 49 38.3333C49 44.2244 44.2244 49 38.3333 49H11.6667C5.77563 49 1 44.2244 1 38.3333Z"
  })));
  const recline = React.useRef(/*#__PURE__*/React.createElement("g", {
    className: classes.back
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M5 13C5 6.37258 10.3726 1 17 1H33C39.6274 1 45 6.37258 45 13V53C45 59.6274 39.6274 65 33 65H17C10.3726 65 5 59.6274 5 53V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M1 29C1 26.7909 2.79086 25 5 25C7.20914 25 9 26.7909 9 29V53C9 55.2091 7.20914 57 5 57C2.79086 57 1 55.2091 1 53V29Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M41 29C41 26.7909 42.7909 25 45 25C47.2091 25 49 26.7909 49 29V53C49 55.2091 47.2091 57 45 57C42.7909 57 41 55.2091 41 53V29Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M1 54.3333C1 51.3878 3.38781 49 6.33333 49H43.6667C46.6122 49 49 51.3878 49 54.3333C49 60.2244 44.2244 65 38.3333 65H11.6667C5.77563 65 1 60.2244 1 54.3333Z"
  })));
  const premium = React.useRef(/*#__PURE__*/React.createElement("g", {
    className: classes.back
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M9 9C9 4.58172 12.5817 1 17 1H33C37.4183 1 41 4.58172 41 9V89C41 93.4183 37.4183 97 33 97H17C12.5817 97 9 93.4183 9 89V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M5 41C5 36.5817 8.58172 33 13 33H37C41.4183 33 45 36.5817 45 41V89C45 93.4183 41.4183 97 37 97H13C8.58172 97 5 93.4183 5 89V41Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M5 73H45V89C45 93.4183 41.4183 97 37 97H13C8.58172 97 5 93.4183 5 89L5 73Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M5 91.6667C5 90.1939 6.19391 89 7.66667 89H42.3333C43.8061 89 45 90.1939 45 91.6667C45 94.6122 42.6122 97 39.6667 97H10.3333C7.38781 97 5 94.6122 5 91.6667Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M1 48C1 45.7909 2.79086 44 5 44C7.20914 44 9 45.7909 9 48V72C9 74.2091 7.20914 76 5 76C2.79086 76 1 74.2091 1 72V48Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M41 48C41 45.7909 42.7909 44 45 44C47.2091 44 49 45.7909 49 48V72C49 74.2091 47.2091 76 45 76C42.7909 76 41 74.2091 41 72V48Z"
  })));
  let svgContent = standard.current;
  if (category === 'recline') {
    svgContent = recline.current;
  } else if (category === 'premium') {
    svgContent = premium.current;
  }
  const rotateProps = orientation === 'left' && {
    transform: `rotate(-90 0 ${SEAT_ROTATION_Y_OFFSETS[category][size]})`
  };
  const petContentShape = React.useRef(/*#__PURE__*/React.createElement("div", {
    className: cx(classes.backLeft, classes[state], classes[size], classes[category], classes[orientation], classes[getSizeClassKey(size, category)])
  }, /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, rotateProps, {
    className: cx(classes[size], classes[category]),
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: classes.shape,
    strokeWidth: "2",
    d: containerShape
  })), icon));
  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
    className: cx(classes[size], classes[category], classes[orientation], className)
  }, other), petsAllowed && /*#__PURE__*/React.createElement("div", null, petContentShape.current), !petsAllowed && /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, rotateProps, {
    className: cx(classes[size], classes[category], classes[state]),
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), svgContent));
};
var _default = exports.default = SeatBase;